import { Pipe, type PipeTransform } from '@angular/core';
import { CocheraNivel, CocheraSinNivel, findCocheraByNumeroOLabel, getCocheraLabel } from '@pages/consorcios/consorcios.config';

/**
 * Nombre para mostrar de una cochera: su label guardado, si no el label de la estructura del consorcio
 * (por ejemplo cocheras cargadas antes de guardar el label o creadas por el agente), y si no el número.
 * Uso: {{ cochera | appCocheraNombre : consorcio?.cocheras }}
 */
@Pipe({
    name: 'appCocheraNombre',
    standalone: true,
})
export class CocheraNombrePipe implements PipeTransform {
    transform(
        cochera: { nivel?: string | number, numero?: string | number, label?: string } | null | undefined,
        cocheras?: CocheraNivel[] | CocheraSinNivel
    ): string {
        if (!cochera) return '';
        return cochera.label || getCocheraLabel(cocheras, cochera.nivel, cochera.numero) || String(cochera.numero ?? '');
    }
}

/**
 * Ayuda para los campos donde se escribe a mano el número o la etiqueta de una cochera:
 * "Nº 3 - ETIQUETA" si la cochera tiene etiqueta, "" si es un número sin etiqueta y un aviso si no existe.
 * Uso: {{ {nivel, valor} | appCocheraAyuda : consorcio?.cocheras }}
 */
@Pipe({
    name: 'appCocheraAyuda',
    standalone: true,
})
export class CocheraAyudaPipe implements PipeTransform {
    transform(
        campo: { nivel?: string | number, valor?: string | number } | null | undefined,
        cocheras?: CocheraNivel[] | CocheraSinNivel
    ): string {
        if (!campo || campo.valor === undefined || campo.valor === null || String(campo.valor).trim() === '' || !cocheras) return '';
        const unidad = findCocheraByNumeroOLabel(cocheras, campo.nivel, campo.valor);
        if (!unidad) return 'No existe esa cochera en el nivel indicado';
        return unidad.label ? `Nº ${unidad.numero} - ${unidad.label}` : '';
    }
}
